<template>
  <b-list-group-item style="padding-top: 2px;padding-bottom: 2px;">
    <b-row no-gutters>
      <b-col md="3" sm="6">
        {{this.initialValue.usuari.nomUsuari}}
      </b-col>
      <b-col md="3" sm="6">
        {{ this.initialValue.dataHora!=null?this.initialValue.dataHora:'' }}
      </b-col>
      <b-col md="3" sm="6">
        {{this.initialValue.recurs}}
      </b-col>
      <b-col md="2" sm="6">
        {{this.initialValue.tipusPeticio}}
      </b-col>
      <b-col md="1" sm="6">
        {{this.initialValue.adreca}}
      </b-col>
    </b-row>
  </b-list-group-item>

</template>

<script>

export default {
  name: "ItemAudit",
  components: {
  },
  props: {
    initialValue:{
      type: Object,
      required: true
    }
  }
};
</script>

<style>
.label-usuari{
  font-weight: 500;
  font-size: 14px;
}
.btn-group-usuari{
  text-align: right;
}
.btn.disabled{
  color: #5f5f69;
}
.tags-rols li:last-child{
  display: none;
}
.tags-rols{
  background-color: white;
  border: 1px solid white;
}
.tags-rols button.close {
  display: none;
}

</style>